// PRHero.js - New Zealand
import React from 'react';
import { motion } from 'framer-motion';
import { CALENDLY_PR_NEW_ZEALAND } from '../../../constants';

const PRHero = () => {
  const handleBookConsultation = () => {
    if (CALENDLY_PR_NEW_ZEALAND) {
      window.open(CALENDLY_PR_NEW_ZEALAND, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto h-full grid md:grid-cols-2">
        {/* Left Content */}
        <div className="flex flex-col justify-center px-4 md:px-8 py-12 bg-surface">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <span className="inline-block bg-white text-secondary text-xs font-light px-4 py-2 rounded-md mb-4">
              New Zealand - Permanent Residency
            </span>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-primary leading-tight mb-6">
              Building a Life in New Zealand
            </h1>
            
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8 max-w-xl font-light">
              Residence in New Zealand rests on points, on skilled employment and on picking the right category to apply under. We help you read all three correctly, whether the Skilled Migrant Category is the fit or a regional route serves you better, and we prepare the application with you from the first assessment onwards.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleBookConsultation}
                className="bg-primary hover:bg-primary-hover text-white font-normal text-sm px-8 py-3 rounded-lg transition-colors text-center"
              >
                Arrange a PR Consultation
              </button>
            </div>
          </motion.div>
        </div>

        {/* Right Image */}
        <div className="relative hidden md:block">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${require('../../../assets/newzealand-pr-hero.jpg')})`,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default PRHero;
